import React, { useEffect } from 'react';
import { Button } from '../Button';
import { useTranslation } from '../../../hooks/useTranslation';
import cc from 'classcat';

interface DrawerButton {
    text: string;
    variant?: 'contained' | 'text' | 'bordered' | 'underline' | 'danger';
    onClick: () => void;
    icon?: string;
    className?: string;
    disabled?: boolean;
}

interface DrawerProps {
    open: boolean;
    title: string;
    className?: string;
    content?: React.ReactNode;
    children?: React.ReactNode;
    onClose: () => void;
    leftButtons?: DrawerButton[];
    rightButtons?: DrawerButton[];
    showFooter?: boolean;
}

const Drawer: React.FC<DrawerProps> = ({ open, title, children, showFooter, content, onClose, leftButtons, rightButtons, className }) => {
    const { t } = useTranslation('common');

    useEffect(() => {
        document.body.style.overflow = open ? 'hidden' : '';
    }, [open]);

    if (!open) return null;

    const drawerContent = children || content;

    return (
        <div className="drawer-overlay" onClick={onClose}>
            <div className={cc(['drawer', className])} onClick={e => e.stopPropagation()}>
                <div className="drawer-header">{title && <h1>{title}</h1>}</div>

                <div className="drawer-content">{drawerContent}</div>

                {showFooter && (
                    <div className="drawer-footer">
                        <div className="left-buttons">
                            {leftButtons?.map((btn, index) => (
                                <Button
                                    key={index}
                                    text={btn.text}
                                    variant={btn.variant || 'text'}
                                    onClick={btn.onClick}
                                    iconSrc={btn.icon}
                                    className={btn.className}
                                />
                            ))}
                        </div>

                        <div className="right-buttons">
                            {rightButtons?.map((btn, index) => (
                                <Button key={index} text={btn.text} variant={btn.variant || 'text'} onClick={btn.onClick} disabled={btn.disabled} />
                            ))}
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
};

export default Drawer;
